import SectionHeading from './SectionHeading';

const PRINCIPLES = [
  { icon: 'ri-file-search-line', title: '客观汇总', desc: '只做热点梳理，不夹带主观定调，把事实与话题原貌交给你判断。' },
  { icon: 'ri-filter-3-line', title: '去噪提速', desc: '过滤低质与重复信息，帮你从信息流里快速捞出真正值得一吃的大瓜。' },
  { icon: 'ri-emotion-laugh-line', title: '轻松好读', desc: '用轻量的方式讲清楚来龙去脉，假期补瓜也能轻松无压力。' },
];

const REVIEWS = [
  {
    name: '返程路上的小林',
    quote: '堵在路上刷完整个盘点点，突然觉得被堵也没那么难熬了，同车人都在吃瓜。',
  },
  {
    name: '宅家派阿言',
    quote: '人没出门，瓜一个没少。热榜分区很清楚，一下就找到自己感兴趣的。',
  },
  {
    name: 'City Walk 玩家Momo',
    quote: '假期的见闻分享很真实，好几条都种草了，下次假期照这个路线走。',
  },
];

export default function About() {
  const goTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <section id="about" className="scroll-mt-24 bg-gradient-to-b from-background-50 to-accent-50/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="关于本站 · ABOUT"
          title="关于"
          accent="五一爆料"
          desc="我们是一群爱看热闹也爱整理内容的编辑，想在信息爆炸的假期里，帮你把值得关注的瓜都捡起来摆好。"
        />

        <div className="mt-12 grid items-center gap-8 lg:grid-cols-2">
          <div>
            <h3 className="font-heading text-2xl text-foreground-900">让"吃瓜"这件事，变得更轻松有条理</h3>
            <p className="mt-4 leading-relaxed text-foreground-700">
              每年小长假，网络上总会同时爆发无数值得关注的话题：有人赶在返程路上、有人挤在热门景区、
              也有人宅在家里快乐刷剧。信息分散在各处，往往顾此失彼。五一爆料想做的，就是把这些散落的热点
              汇总成一份条理清晰的"假期追更清单"。
            </p>
            <p className="mt-3 leading-relaxed text-foreground-700">
              我们不追逐瞬时流量的喧嚣，也不做空洞的标题党，而是筛出有讨论价值、有真实趣味的内容，
              再按事件、榜单、热梗与现场见闻分门别类地呈现。开箱即用、无需注册，随时打开就能快速追上大家正在聊的话题。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {['热点事件汇总', '话题热榜', '热梗盘点', '假期现场见闻'].map((k) => (
                <span
                  key={k}
                  className="inline-flex items-center gap-1.5 rounded-full border border-accent-200 bg-accent-100/70 px-3.5 py-1.5 text-sm text-accent-800"
                >
                  <i className="ri-check-double-line"></i>
                  {k}
                </span>
              ))}
            </div>
          </div>

          <div className="grid gap-4">
            {PRINCIPLES.map((p) => (
              <div
                key={p.title}
                className="flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-accent-500 text-xl text-background-50">
                  <i className={p.icon}></i>
                </span>
                <div>
                  <h4 className="font-heading text-lg text-foreground-900">{p.title}</h4>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 口碑 */}
        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {REVIEWS.map((r) => (
            <figure
              key={r.name}
              className="rounded-2xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-secondary-300"
            >
              <div className="flex gap-1 text-secondary-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">"{r.quote}"</blockquote>
              <figcaption className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                  <i className="ri-user-3-line"></i>
                </span>
                {r.name}
              </figcaption>
            </figure>
          ))}
        </div>

        {/* 投稿 / 联系 */}
        <div className="mt-12 flex flex-col items-center gap-4 rounded-3xl bg-background-50 p-6 text-center md:p-10">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-500 text-2xl text-background-50">
            <i className="ri-mail-send-line"></i>
          </span>
          <h3 className="font-heading text-2xl text-foreground-900">发现了新瓜？来找我们聊聊</h3>
          <p className="max-w-xl text-sm leading-relaxed text-foreground-600">
            无论是假期里的现场见闻，还是你觉得值得上热榜的话题，都欢迎投稿。
            内容一经采用，我们会整理补录进对应栏目，和更多瓜友一起分享。
          </p>
          <div className="flex flex-col items-center gap-3 sm:flex-row">
            <a
              href="mailto:hello@wuyi-baoliao.example"
              className="whitespace-nowrap inline-flex cursor-pointer items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-line"></i>
              hello@wuyi-baoliao.example
            </a>
            <button
              type="button"
              onClick={goTop}
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200"
            >
              <i className="ri-arrow-up-line"></i>
              回到顶部继续吃瓜
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}